var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"emoji-picker"},_vm._l((_vm.emojiList),function(obj,index){return _c('div',{staticClass:"emotion-item cursor-p",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick(obj)}}},[_c('img',{staticClass:"emoji-img",attrs:{"src":_vm.getUrl(index)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }